import { Container, Heading, Spacer, useBreakpointValue } from "@chakra-ui/react"
import StaticBanner from "./StaticBanner"
import UserMenu from "../Common/UserMenu"
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT

type TitleBarProps = {
  title: string
}

export function TitleBar({ title }: TitleBarProps) {
  const isMobile = useBreakpointValue({ base: true, md: false })

  return (
    <>
      {ENVIRONMENT == "staging" && <StaticBanner />}
      <Container
        minW="full"
        bg="main"
        borderBottomRadius={15}
        position="sticky"
        top={ENVIRONMENT == "staging" ? 10 : 0}
        zIndex={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Heading size="3xl" py={4} pl={8} color="white">
          {title}
        </Heading>

        {!isMobile &&
           <UserMenu />
        }
      </Container>
      <Spacer h={2} />
    </>
  )
}

export default TitleBar
